import { Vue } from "vue-property-decorator";

export default class ToolTip {
  public id: any;
  public type: any;
  private view!: any;
  private vm!: Vue;
  private postion!: any;
  private xoffset: number = 0;
  private yoffset: number = 0;

  public constructor(
    view: any,
    tooltip: Vue.Component,
    content: any,
    position: any,
    prop?: any
  ) {
    this.view = view;
    this.postion = position;

    if (typeof content == "boolean") {
      content = {};
    }
    if (prop) {
      for (let field in prop) {
        content[field] = prop[field];
      }
      this.xoffset = prop.xoffset || 0;
      this.yoffset = prop.yoffset || 0;
    }
    this.create(tooltip, content);
  }
  private create(tooltip: Vue.Component, props: any) {
    props.parent = this;
    this.vm = new Vue({
      // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
      render: (h) => h(tooltip, { props }) // render 生成虚拟dom  {props: props}
    }).$mount(); // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载
    (this.vm.$el as any).style.position = "absolute";
    let gdContainer = this.view.getContainer();
    gdContainer.appendChild(this.vm.$el);
    //确保有class
    let className = props.className || "tooltip";
    if (!this.vm.$el.classList.contains(className)) {
      this.vm.$el.classList.add(className);
    }

    this.changeText();
    this.init();
  }
  //计算tooltip，偏移位置；
  private subLocate(location: string): { xoffset: number; yoffset: number } {
    let xoffset: number = 0;
    let yoffset: number = 0;
    const width = this.vm.$el.clientWidth;
    const height = this.vm.$el.clientHeight;
    switch (location) {
      case "top":
        xoffset = 0 - width / 2 + this.xoffset;
        yoffset = 0 - height - this.yoffset;;
    }
    return { xoffset: xoffset, yoffset: yoffset };
  }
  private init() {
    // this.view.addEventListener('dragstart', () => {
    //   this.changeText();
    // });
    this.view.addEventListener("dragging", () => {
      this.changeText();
    });
    this.view.addEventListener("dragend", () => {
      this.changeText();
    });
    this.view.addEventListener("zoomstart", () => {
      this.changeText();
    });
    this.view.addEventListener("zoomend", () => {
      this.changeText();
    });
    // this.view.addEventListener('mousemove', () => {
    //   this.changeText();
    // });
  }
  private changeText() {
    let pixel = this.view.pointToPixel(this.postion);//获取图上像素坐标
    const offset: { xoffset: number; yoffset: number } = this.subLocate("top");
    Object(this.vm.$el).style.left = pixel.x + offset.xoffset + "px";
    Object(this.vm.$el).style.top = pixel.y + offset.yoffset + "px";
  }
  public remove() {
    // 回收组件
    this.view.getContainer().removeChild(this.vm.$el); // 删除元素
    this.vm.$destroy(); // 销毁组件
    // this.view.removeEventListener('dragstart', () => {
    //   this.changeText();
    // });
    this.view.removeEventListener("dragging", () => {
      this.changeText();
    });
    this.view.removeEventListener("dragend", () => {
      this.changeText();
    });
    this.view.removeEventListener("zoomstart", () => {
      this.changeText();
    });
    this.view.removeEventListener("zoomend", () => {
      this.changeText();
    });
    // this.view.removeEventListener('mousemove', () => {
    //   this.changeText();
    // });
  }

  //清除所有指定的tooltips（可通过id和class指定）
  public static clear(view: any, id?: string | undefined, className?: string) {
    let tools: any = document.getElementsByClassName(className || "tooltip");

    Array.from(tools).forEach((el: any, index: number) => {
      if (id == undefined || el.id == id) {
        el.parentElement.removeChild(el);
      }
    }, this);
  }
}
